import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";

// Field names and the `status` enum below must match the `contracts` table
// exactly (see api/src/db/migrations/20260608200003_create_documents_s21.ts)
// and the fields the backend controller actually persists
// (api/src/packages/company/v1/modules/contracts/controller.ts) — this type
// previously described a schema ("cancelled" / "renewed" statuses,
// description/currency/signed_at fields) that was never implemented, so
// those statuses crashed on save and those fields silently never persisted.
export interface IContract {
  id: number;
  uuid: string;
  company_id: number;
  client_id: number;
  title: string;
  reference: string | null;
  start_date: string | null;
  end_date: string | null;
  value: number | null;
  status: "draft" | "active" | "expired" | "terminated" | "pending_renewal";
  billing_frequency: "monthly" | "quarterly" | "annually" | "job_based";
  auto_renew: boolean | number;
  renewal_reminder_days: number;
  notes: string | null;
  document_url: string | null;
  created_at: string;
  updated_at: string | null;
  client_name?: string | null;
  client_email?: string | null;
}

export interface IContractCreatePayload {
  client_id: number;
  title: string;
  reference?: string;
  start_date?: string;
  end_date?: string;
  value?: number;
  status?: string;
  billing_frequency?: string;
  auto_renew?: boolean;
  renewal_reminder_days?: number;
  notes?: string;
  document_url?: string;
}

export interface IContractUpdatePayload extends IContractCreatePayload {
  id: number;
}

export async function listContracts(qData: QData): Promise<AxiosResponse<TResponseWithQData<IContract[]>>> {
  return axios.get(API_ENDPOINTS.CONTRACT_LIST, { params: qData });
}

export async function createContract(data: IContractCreatePayload): Promise<AxiosResponse<TResponse<IContract>>> {
  return axios.post(API_ENDPOINTS.CONTRACT_CREATE, data);
}

export async function updateContract(data: IContractUpdatePayload): Promise<AxiosResponse<TResponse<IContract>>> {
  return axios.put(`${API_ENDPOINTS.CONTRACT_UPDATE}/${data.id}`, data);
}

export async function deleteContract(id: number): Promise<AxiosResponse<TResponse<null>>> {
  return axios.delete(`${API_ENDPOINTS.CONTRACT_DELETE}/${id}`);
}
